<template>
    <div class="yearSwiper borderTop borderLRB">
        <div class="swiper-container" ref="yearSwiper">
            <div class="swiper-wrapper">
                <div class="swiper-wrapper-box">
                    <div :class="i==yearIndex?'swiper-slide-active':''" class="swiper-slide color999" v-for="(item, i) in yearList" :key="i" @click="yearClick(item,i)">
                        {{item}}
                    </div>
                </div>
            </div>
<!--            <div class="swiper-button-next" @click="nextClick"></div>-->
<!--            <div class="swiper-button-prev" @click="preClick"></div>-->
        </div>

    </div>
</template>

<script>
import Swiper from "swiper";
import { postDate } from '@/api/company'

// 调试开关：true 打印接口数据，调完改成 false（或整段删掉，搜 DEBUG_LOG）
const DEBUG_LOG = false

export default {
    name: "yearSwiper",
    props: {
        // 由父组件（auctionResult.vue）在拿到机构信息后传入。
        // 机构 code 是这个接口的必填参数，不传后端直接返回 code=-500 且 data=null。
        organCode: {
            type: String,
            default: ''
        }
    },
    data(){
        return{
            yearList:['全部'],
            option:{
                slidesPerView: 3,
                observer:true,
                observeParents:true,
            },
            yearIndex:0,
        }
    },
    watch: {
        // organCode 是父组件异步拿到的（postDetail 返回后才有值），
        // 所以不能在 mounted 里直接请求——那时它还是空串。
        // 用 immediate watch：有值才发请求，值变了（切机构）重新拉。
        organCode: {
            immediate: true,
            handler(val) {
                if (!val) return
                this.postDate()
            }
        }
    },
    mounted() {
        // this.$nextTick(()=>{
        //     setTimeout(function (){
        //         new Swiper('.swiper-container', {
        //             slidesPerView: 2,
        //             spaceBetween: 40,
        //             navigation: {
        //                 nextEl: '.swiper-button-next',
        //                 prevEl: '.swiper-button-prev',
        //             },
        //         });
        //     },500)
        // })
    },
    methods:{
        yearClick(item,i){
            this.$emit('clickYearSwiper', item)
            // this.yearIndex=i;
            // this.$emit('yearChange',item);
        },
        nextClick(){
            this.$refs.yearSwiper.slideNext();
        },
        preClick(){
            this.$refs.yearSwiper.slidePrev();
        },
        postDate() {
            // 逐层判空：接口在参数不全或后端异常时会返回 code=-500 且 data 为 null，
            // 原来直接 res.data.list.length 会抛
            // "Cannot read properties of null (reading 'list')"，
            // 而且没有 .catch，异常会变成未捕获的 promise rejection。
            if (DEBUG_LOG) console.log('[调试] ③ 请求 /v1/session/years  参数=', { organ_code: this.organCode })
            postDate({ organ_code: this.organCode })
                .then(res => {
                    if (DEBUG_LOG) {
                        console.log('[调试] ③ 返回 /v1/session/years  code=', res && res.code, ' data=', res && res.data)
                        console.table(((res && res.data && res.data.list) || []).map((x, i) => ({ 下标: i, year: x && x.year })))
                    }
                    const list = (res && res.data && res.data.list) || []
                    const years = ['全部']
                    for (let i = 0; i < list.length; i++) {
                        if (list[i] && list[i].year) years.push(list[i].year)
                    }
                    // 整体替换而不是 push，避免切换机构时年份累加
                    this.yearList = years
                })
                .catch(err => {
                    console.error('[yearSwiper] 年份列表获取失败', err)
                })
        }
    },
}
</script>

<style scoped lang="scss">
@import '@/assets/css/auctionCompany.scss';
.yearSwiper{
    position: relative;
    .swiper-container{

        overflow-x: auto;
        overflow-y: hidden;
        width: 600px;
        margin: 0 auto;
        .swiper-wrapper{
            padding: 18px 0;
            height: 58px;
            white-space: nowrap;
        }
        .swiper-wrapper-box{}
        .swiper-slide{width:54px!important;height:20px;display:inline-block;cursor:pointer;font: normal 20px/19px Verdana;margin-right: 28px;}
        .swiper-slide-active,.swiper-slide:hover{color: #000;}
        .swiper-button-prev, .swiper-button-next{width:10px;height:19px;background-image: url("../../../../assets/imgs/old/yearBg.png");
            cursor:pointer;overflow: hidden;background-repeat: no-repeat;display: inline-block;
            position: absolute; margin-top: -39px; }
        .swiper-button-prev:after,.swiper-button-next:after{content:'';}
        .swiper-button-next{background-position: left -136px;margin-right: 15px;
            margin-left: 7px;left: 20px}
        .swiper-button-prev{background-image: url("../../../../assets/imgs/old/yearBg.png");background-position: left -170px;margin-left: 19px;
            margin-right: 7px;right: 20px}
    }
}

</style>